import { useMemo } from 'react';

import { type ExamEventSession } from './types';
import { mapTimesToDisplaySessions } from './utils';

export function useSessionManagement(initialSessions: ExamEventSession[]) {
  const { sessions, totalDuration } = useMemo(() => {
    return mapTimesToDisplaySessions(initialSessions);
  }, [initialSessions]);

  return {
    sessions,
    totalDuration,
  };
}
